import FmdBaseDal from "./FmdBaseDal"

import { BagDto, PatientDto, BagItemDto, BagSearchDto, PatientSearchResultDto} from "../dto/FMD/Models"
import Formatter from "../components/corecontrols/formatters/Formatter";
import moment from "moment"
import UiSession from "../Tracking/LogManager";
import axios from 'axios'

export default class FmdDal extends FmdBaseDal {

    unitId: string;

    constructor(unitId: string, uiSession: UiSession) {
        super(uiSession);

        this.unitId = unitId;
        //this._baseUri = "http://localhost:5005"
        //this._baseUri = "https://sit-api.vcaresystems.co.uk/"
        /* "http://localhost:5001/"*/
    }

    public async GetBags(skip: number, take: number, patientId: string, statuses: Array<number>, query: string): Promise<Array<BagDto>> {

        var url = "/api/PatientBag/GetPatientBag?unitId=" + this.unitId + "&skip=" + skip + "&take=" + take;
        if (query) {
            url += "&searchTerm=" + query
        }
        if (patientId) {
            url += "&patientId=" + patientId
        }
        if (statuses && statuses.length > 0) {
            for (var status of statuses) {
                url += "&bagStatusList=" + status;
            }
        }
        return await this.Get<BagSearchDto>(url).then(d => {
            console.log(d.bagList.data);
            return d.bagList.data
        });
    }


    public async GetDeliveredBags(searchText: string, fromDate: Date, toDate: Date): Promise<Array<BagDto>> {

        var searchStr = ""
        if (moment(fromDate).isValid() && moment(toDate).isValid()) {
            searchStr += "&fromDate=" + moment(fromDate).format("YYYY-MM-DD");
            searchStr += "&toDate=" + moment(toDate).format("YYYY-MM-DD");
        } 

        if (searchText && searchText.length > 0) {
            searchStr += "&searchTerm=" + searchText;
        }

        var url = "/api/PatientBag/GetPatientBag?unitId=" + this.unitId + "&bagStatusList=0&bagStatusList=30" + searchStr;
        
        return await this.Get<BagSearchDto>(url).then(d => {
            console.log(d.bagList.data);
            return d.bagList.data
        });
    }
    public async GetActiveBags(): Promise<Array<BagDto>> {
        var url = "v1/Bag/active"
        url = "/api/PatientBag/GetPatientBag?unitId="+this.unitId+"&bagStatusList=10&bagStatusList=20"
        return await this.Get<BagSearchDto>(url).then(d => {
            console.log(d.bagList.data);
            return d.bagList.data
        });
    }

    public async GetBag(bagId: string): Promise<BagDto> {
        //var url = "v1/Bag/" + bagId;
        //return await this.Get<BagDto>(url);
        var url = "/api/PatientBag/GetPatientBag?unitId="+this.unitId+"&bagId=" + bagId +"&needBagDetails=true"
        return await this.Get<BagSearchDto>(url).then(d => {
            var bags = d.bagList.data
            return bags[0]
        });

    }

    public async SaveBagItem(bag: BagDto, bagItemDto: BagItemDto): Promise<BagItemDto|null>{
        var url = "/api/PatientBag/SetPatientBag?unitId="+this.unitId+"";
        bag.patientBagMeds = []
        if (!bagItemDto.id) bagItemDto.id = "00000000-0000-0000-0000-000000000000";
        if (!bagItemDto.isRemoved) bagItemDto.isRemoved = false;
        bag.patientBagMeds.push(bagItemDto);
        return this.Post2<BagDto, BagSearchDto>(url, bag).then(bg => {
            var bgT = (bg as BagSearchDto).bagList.data[0];
            for (var bi of bgT.patientBagMeds) {
                if (bi.sn == bagItemDto.sn) {
                    return bi;
                }
            }
            return null;
        });
    }
    public async DeleteBag(bagId: string, patientId: string) {
        var url = "/api/PatientBag/SetPatientBag?unitId=" + this.unitId;
        var data = {
            id: bagId,
            unitId: this.unitId,
            patientId: patientId,
            isRemoved: true
        };

        return await this.Post2<any, BagSearchDto>(url, data)
            .then(d => {
                console.log(d);
                return (d as BagSearchDto).bagList.data[0];
            })
    }

    public async UpdateBagStatus(bagId: number, status: string): Promise<BagDto> {
        var url = "/api/PatientBag/UpdateBagStatus?unitId="+this.unitId+"" + "&bagId=" + bagId + "&bagStatus=" + status;
        return await this.Get<BagSearchDto>(url).then(d => {
            var bags = d.bagList.data
            return bags[0]
        });
    }


    public async UndoDecommision(bagId: number, id: string): Promise<BagItemDto | null> {

        var url = "/api/PatientBag/MedsFMDAction?unitId="+this.unitId+"" + "&bagId=" + bagId + "&action=UndoDecom";
        var items = [];
        items.push(id);
        return this.Post2<Array<string>, BagSearchDto>(url, items).then(bg => {
            var bgT = (bg as BagSearchDto).bagList.data[0];
            for (var bi of bgT.patientBagMeds) {
                if (bi.id == id) {
                    return bi;
                }
            }
            return null;
        })
    }

    public async GetPatient(patientId : string): Promise<PatientDto> {
        var url = "/api/Patient/GetFmdPatient?&id=" + patientId;
        return await this.Get<PatientDto>(url);
    }



    public async GetPatients(skip: number, take: number, query: string, sortColumnName:string, sortDirection:string): Promise<PatientSearchResultDto> {
        var url = "/api/Patient/GetAllPatientsForUnit?unitId=" + this.unitId + "&skip=" + skip + "&take=" + take;
        if (query) {
            url += "&searchTerm=" + query
        }
        if (sortColumnName) {
            url += "&sortOrder=" + "Patient." + sortColumnName;
            if (sortDirection) {
                url += " " + sortDirection.toUpperCase()
            }
        }

        return await this.Get<PatientSearchResultDto>(url);
    }

    public async SearchPatients(query: string): Promise<Array<PatientDto>> {

        // return this.ElasticSearchPatients(query);
        var url = "/api/Patient/GetAllPatientsForUnit?skip=0&take=100&unitId=" + this.unitId + "&searchTerm=" + query;
        return await this.Get<PatientSearchResultDto>(url).then(d => {
            return d.data
        });
    }


    public async ElasticSearchPatients(query: string): Promise<Array<PatientDto>> {
        var qurl = "/api/Patient/ElasticSearch?skip=0&take=20&unitId=" + this.unitId + "&searchTerm=" + query;
        return await this.Get<PatientSearchResultDto>(qurl).then(d => {
            return d.data
        });
        

    }

    public async UpdateBag(bag: BagDto): Promise<BagDto | null> {
        var url = "/api/PatientBag/SetPatientBag?unitId=" + this.unitId;

        console.log("Trying to update bag for " + bag.id);
        var updateBag = { ...bag };
        updateBag.patientBagMeds = [];
        return await this.Post2<any, BagSearchDto>(url, updateBag)
            .then(d => {
                console.log(d);
                return (d as BagSearchDto).bagList.data[0];
            })
    }

    public async CreateBag(patientId: string): Promise<BagDto | null> {
        var url = "v1/Bag/create?patientId=" + patientId;
        url = "/api/PatientBag/SetPatientBag?unitId=" + this.unitId;
        var data = {
            id: "00000000-0000-0000-0000-000000000000",
            unitId: this.unitId,
            patientId: patientId
        };

        console.log("Trying to create bag for " + patientId)

        return await this.Post2<any, BagSearchDto>(url, data)
            .then(d => {
                console.log(d);
                return (d as BagSearchDto).bagList.data[0];
            })
    }


    public async CreateBagWithAggCode(aggCode: string): Promise<BagDto | null> {
        var url = "/api/PatientBag/SetPatientBag?unitId=" + this.unitId;
        var data = {
            id: "00000000-0000-0000-0000-000000000000",
            unitId: this.unitId,
            aggregatedCode: aggCode
        };

        console.log("Trying to create bag for Agg Code" + aggCode)

        return await this.Post2<any, BagSearchDto>(url, data)
            .then(d => {
                console.log(d);
                return (d as BagSearchDto).bagList.data[0];
            })
    }



    public async SavePatient(p: PatientDto) {
        var url = "/api/Patient/SetFMDPatient?unitId=" + this.unitId;
        p.dob = moment(p.dob).hour(12).toDate();
        return this.Post2<PatientDto, PatientDto>(url, p);
    }
    //public async GetBagItems(bagId: string): Promise<Array<BagItemDto>> {
    //    var url = "/v1/BagItem/" + bagId;
    //    return await this.Get<Array<BagItemDto>>(url);
    //}


    //public async SearchPatientByFields(firstName: string, lastName: string, dob: Date, postCode: string): Promise<Array<PatientDto>> {
    //    var fdob = moment(dob).format("YYYYMMDD");
    //    var url = "v1/Patient/search/fields?A=1"

    //    url += "&firstName=" + (firstName)
    //    url += "&lastName=" + (lastName)
    //    url += "&dob=" + (fdob)
    //    url += "&postCode=" + (postCode)
    //    return await this.Get<Array<PatientDto>>(url);
    //}

    //public async GetBagItem(bagId: number, bagItemId: number): Promise<BagItemDto> {
    //    var url = "v1/BagItem/" + bagId + "/" + bagItemId;
    //    return await this.Get<BagItemDto>(url);
    //}
    //public async DeleteBagItem(bagId: number, bagItemId: number) {
    //    var url = "v1/BagItem/" + bagId + "/" + bagItemId;
    //    return await this.Delete<any>(url);
    //}

    //public async CreateBagItem(bagId: number, code: string) {
    //    var url = "v1/BagItem";
    //    var item = new BagItemDto();
    //    item.bagId = bagId;
    //    item.itemCode = code;
    //    return await this.Post<BagItemDto>(url, item);
    //}
}


// WEBPACK FOOTER //
// ./ClientApp/scripts/FmdDal.ts